// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"aa4d0bce","143":"58ab3881","205":"d0c3445a","390":"f01e7c93","394":"78be8ee6","670":"4c881619","775":"1f4d0d5f","878":"0a863351","927":"5da0cba3"}[chunkId] + ".chunk.js";
};